<template lang="pug">
b-autocomplete(
  v-model="query"
  icon="magnify"
  :placeholder="placeholder"
  :data="results"
  :keep-first="true"
  :loading="settings.searching"
  @input="search"
  @select="select"
  expanded
)
  template(slot-scope="props")
    .result
      b-icon(:icon="props.option._icon" size="is-small")
      b {{ props.option._label }}
      small(v-if="props.option._index === 'doxa_episodes'") {{ props.option._source.pub_date | date }}
  template(slot="empty") No results
</template>

<script>
import { mapGetters } from 'vuex';
import { SEARCH } from '@/utils/http';
import * as getters from '@/store/types/getters';

export default {
  name: 'media-search',
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
    }),
  },
  data() {
    return {
      groups: {},
      query: null,
      results: [],
      settings: {
        searching: false,
      },
    };
  },
  methods: {
    async search(val) {
      if (!_.isEmpty(val)) {
        this.settings.searching = true;
        const actions = [];
        this.indexes.forEach(index => actions.push(this.searchIndex(index, val)));
        await Promise.all(actions);
        this.results = [];
        this.indexes.forEach((index) => {
          this.results = this.results.concat(this.groups[index]);
        });
        this.settings.searching = false;
      }
    },
    async searchIndex(index, text) {
      const payload = {
        suggest: {
          suggestions: {
            text,
            completion: {
              field: 'suggest',
              contexts: {
                account_id: [this.account.id],
              },
            },
          },
        },
      };
      const { data } = await SEARCH.post(`/${index}/_search`, payload);
      const options = _.map(data.suggest.suggestions[0].options, (opt) => {
        switch (opt._index) {
          case 'doxa_episodes':
            opt._icon = 'video';
            opt._label = opt._source.title;
            break;
          case 'doxa_channels':
            opt._icon = 'podcast';
            opt._label = opt._source.title;
            break;
          case 'doxa_episode_collections':
            opt._icon = 'library-video';
            opt._label = opt._source.title;
            break;
          case 'doxa_speakers':
            opt._icon = 'account';
            opt._label = opt._source.full_name;
            break;
          case 'doxa_ministries':
            opt._icon = 'church';
            opt._label = opt._source.name;
            break;
          case 'doxa_events':
            opt._icon = 'calendar-blank';
            opt._label = opt._source.title;
            break;
          default:
        }
        return opt;
      });
      this.groups[index] = options || [];
      return options;
    },
    select(result) {
      this.$emit('select', result);
    },
  },
  props: {
    indexes: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  align-items: center;
  .icon {
    margin-right: 0.35rem;
  }
  small {
    margin-left: 0.35rem;
    color: #7a7a7a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MediaSearch.vue